/* Landing do spray — comportamento de todas as secoes */
(function(){
  var root = document.querySelector('.sp');
  if (!root) return;

  var CFG_SP  = window.SPRAY || {};
  var INS_ID  = CFG_SP.insuranceId || 0;

  /* ---------- ancoras: rolam sem escrever #order na URL ----------
     Sem isso, um clique no CTA grava o hash no endereco e, a partir dai,
     o mesmo link passa a abrir direto na oferta em vez do topo. */
  Array.prototype.forEach.call(root.querySelectorAll('a[href="#order"]'), function(a){
    a.addEventListener('click', function(e){
      var alvo = document.getElementById('order');
      if (!alvo) return;
      e.preventDefault();
      var destino = alvo.getBoundingClientRect().top + window.pageYOffset - 10;
      var partiu = window.pageYOffset;
      window.scrollTo({ top: destino, behavior: 'smooth' });
      setTimeout(function(){
        if (Math.abs(window.pageYOffset - partiu) < 2) {
          var antes = document.documentElement.style.scrollBehavior;
          document.documentElement.style.scrollBehavior = 'auto';
          window.scrollTo(0, destino);
          document.documentElement.style.scrollBehavior = antes;
        }
      }, 500);
    });
  });

  /* se alguem chegar com #order na URL (link antigo), limpa o endereco */
  if (location.hash === '#order' && history.replaceState) {
    history.replaceState(null, '', location.pathname + location.search);
  }

  /* ---------- selecao de kit ---------- */
  var kits = [].slice.call(root.querySelectorAll('.sp-kit'));
  var sel  = root.querySelector('.sp-kit.on') || kits[0];

  function pinta(){
    kits.forEach(function(k){ k.classList.toggle('on', k === sel); });
    var p = root.querySelector('#spStickyPrice'), n = root.querySelector('#spStickyKit');
    if (p) p.textContent = sel.getAttribute('data-price');
    if (n) n.textContent = sel.getAttribute('data-name') + ' · ' + sel.querySelector('.of').textContent;
  }
  kits.forEach(function(k){
    k.addEventListener('click', function(e){
      sel = k; pinta();
      if (e.target.classList.contains('bt')) comprar();
    });
  });
  pinta();

  /* ---------- galeria do hero ---------- */
  var main = root.querySelector('#spHeroMain');
  var thumbs = [].slice.call(root.querySelectorAll('#spThumbs button'));
  thumbs.forEach(function(b){
    b.addEventListener('click', function(){
      var img = b.querySelector('img');
      if (main && img) main.src = img.src;
      thumbs.forEach(function(x){ x.classList.remove('on'); });
      b.classList.add('on');
    });
  });

  /* ---------- comparador arrastavel ----------
     O painel de testes nao anima transicoes, entao a posicao e escrita direto
     no style a cada movimento, sem transition. */
  (function(){
    var cmp = root.querySelector('#spCmp');
    if (!cmp) return;
    var lado = root.querySelector('#spCmpA'), alca = root.querySelector('#spCmpHd');
    var arrastando = false;

    function poe(pct){
      pct = Math.max(2, Math.min(98, pct));
      lado.style.width = pct + '%';
      alca.style.left = pct + '%';
      alca.setAttribute('aria-valuenow', Math.round(pct));
    }
    function doEvento(e){
      var r = cmp.getBoundingClientRect();
      var x = (e.touches ? e.touches[0].clientX : e.clientX) - r.left;
      poe(x / r.width * 100);
    }
    cmp.addEventListener('pointerdown', function(e){ arrastando = true; cmp.setPointerCapture(e.pointerId); doEvento(e); });
    cmp.addEventListener('pointermove', function(e){ if (arrastando) doEvento(e); });
    cmp.addEventListener('pointerup',   function(){ arrastando = false; });
    cmp.addEventListener('pointercancel', function(){ arrastando = false; });
    // fallback para navegador sem pointer events
    cmp.addEventListener('touchmove', function(e){ doEvento(e); }, { passive: true });
    // teclado: setas movem de 5 em 5
    alca.addEventListener('keydown', function(e){
      var atual = parseFloat(lado.style.width) || 50;
      if (e.key === 'ArrowLeft')  { poe(atual - 5); e.preventDefault(); }
      if (e.key === 'ArrowRight') { poe(atual + 5); e.preventDefault(); }
    });
  })();

  /* ---------- carrinho ---------- */
  function ttq_ev(nome){
    try{
      if (!window.ttq || typeof window.ttq.track !== 'function') return;
      var val = parseFloat((sel.getAttribute('data-price')||'').replace(/[^0-9.,]/g,'').replace(',','.')) || 0;
      window.ttq.track(nome, {
        contents: [{ content_id: String(sel.getAttribute('data-vid')), content_type: 'product', content_name: sel.getAttribute('data-name'), quantity: 1, price: val }],
        value: val,
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || CFG_SP.currency || 'EUR'
      }, { event_id: nome + '.' + sel.getAttribute('data-vid') + '.' + Date.now() });
    }catch(e){}
  }

  var ocupado = false;
  function comprar(){
    if (ocupado) return; ocupado = true;
    var itens = [{ id: Number(sel.getAttribute('data-vid')), quantity: 1 }];
    var ins = root.querySelector('#spIns');
    if (ins && ins.checked) itens.push({ id: INS_ID, quantity: 1 });

    fetch('/cart/clear.js', { method:'POST', headers:{'Accept':'application/json'} })
      .then(function(){
        return fetch('/cart/add.js', {
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body: JSON.stringify({ items: itens })
        });
      })
      .then(function(r){ return r.json(); })
      .then(function(){
        ttq_ev('AddToCart'); ttq_ev('InitiateCheckout');
        setTimeout(function(){ window.location.href = '/checkout'; }, 350);
      })
      .catch(function(){ ocupado = false; });
  }
  var sb = root.querySelector('#spStickyBtn');
  if (sb) sb.addEventListener('click', comprar);

  /* ---------- sticky bar: aparece depois do hero ---------- */
  var hero = root.querySelector('.sp-hero');
  var bar  = root.querySelector('#spSticky');
  function checaBar(){
    if (!hero || !bar) return;
    bar.classList.toggle('on', (hero.getBoundingClientRect().bottom < 0));
  }
  window.addEventListener('scroll', checaBar, { passive:true });
  checaBar();

  /* ---------- bolinhas dos carrosseis ---------- */
  function bolinhas(trilho, caixa){
    var t = root.querySelector(trilho), d = root.querySelector(caixa);
    if (!t || !d) return;
    var itens = [].slice.call(t.children);
    itens.forEach(function(_, i){
      var b = document.createElement('button');
      if (i === 0) b.className = 'on';
      b.addEventListener('click', function(){
        t.scrollLeft = itens[i].offsetLeft - t.offsetLeft;
        [].slice.call(d.children).forEach(function(x, j){ x.classList.toggle('on', i === j); });
      });
      d.appendChild(b);
    });
    t.addEventListener('scroll', function(){
      var meio = t.scrollLeft + t.clientWidth / 2, at = 0;
      itens.forEach(function(el, i){
        var c = el.offsetLeft - t.offsetLeft + el.clientWidth / 2;
        if (Math.abs(c - meio) < Math.abs((itens[at].offsetLeft - t.offsetLeft + itens[at].clientWidth/2) - meio)) at = i;
      });
      [].slice.call(d.children).forEach(function(x, j){ x.classList.toggle('on', at === j); });
    }, { passive:true });
  }
  bolinhas('#spVids', '#spVidDots');
  bolinhas('#spTst', '#spTstDots');

  /* ---------- contador da faixa vermelha (minutos/segundos do dia) ---------- */
  (function(){
    var h = root.querySelector('#spUrgH'), m = root.querySelector('#spUrgMin'), sg = root.querySelector('#spUrgSec'), tx = root.querySelector('#spUrgTxt');
    if (!m) return;
    function tick(){
      var agora = new Date();
      var fim = new Date(agora.getFullYear(), agora.getMonth(), agora.getDate() + 1, 0, 0, 0);
      var seg = Math.max(0, Math.floor((fim - agora) / 1000));
      var hh = Math.floor(seg/3600), mm = Math.floor((seg%3600)/60), ss = seg%60;
      h.textContent  = String(hh).padStart(2,'0');
      m.textContent  = String(mm).padStart(2,'0');
      sg.textContent = String(ss).padStart(2,'0');
      if (tx) tx.textContent = 'Nur noch ' + hh + ' Std. ' + mm + ' Min. gültig.';
    }
    tick(); setInterval(tick, 1000);
  })();

  /* ---------- escassez: contador da oferta do dia ----------
     Zera a meia-noite do fuso do visitante. Sem numero inventado de estoque:
     a barra mostra quanto do dia ja passou, o que e verdade e nao promete nada. */
  function relogio(){
    var agora = new Date();
    var fim = new Date(agora.getFullYear(), agora.getMonth(), agora.getDate() + 1, 0, 0, 0);
    var s = Math.max(0, Math.floor((fim - agora) / 1000));
    var h = String(Math.floor(s/3600)).padStart(2,'0');
    var m = String(Math.floor((s%3600)/60)).padStart(2,'0');
    var g = String(s%60).padStart(2,'0');
    var el = root.querySelector('#spTimer');
    if (el) el.textContent = 'Aktion endet in ' + h + ':' + m + ':' + g;
    var barra = root.querySelector('#spStockBar');
    if (barra) barra.style.width = Math.max(6, Math.round(s / 864)) + '%';
    var txt = root.querySelector('#spStockTxt');
    if (txt) txt.textContent = 'Aktionspreis heute';
  }
  relogio();
  setInterval(relogio, 1000);
})();
